package com.raouf.mehrguard.web.i18n

internal val ThaiStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "ตัวตรวจจับ QRishing Kotlin Multiplatform",
    WebStringKey.MenuMain to "เมนูหลัก",
    WebStringKey.MenuSecurity to "ความปลอดภัย",
    WebStringKey.MenuSystem to "ระบบ",
    WebStringKey.NavDashboard to "แดชบอร์ด",
    WebStringKey.NavScanMonitor to "มอนิเตอร์การสแกน",
    WebStringKey.NavScanHistory to "ประวัติการสแกน",
    WebStringKey.NavTrustCentre to "ศูนย์ความน่าเชื่อถือ",
    WebStringKey.NavReports to "รายงาน",
    WebStringKey.NavTraining to "การฝึกอบรม",
    WebStringKey.NavSettings to "การตั้งค่า",
    WebStringKey.QuickActions to "การดำเนินการด่วน",

    // Hero Section
    WebStringKey.HeroTagline to "ปลอดภัย. ออฟไลน์.",
    WebStringKey.HeroTagline2 to "การป้องกันที่อธิบายได้.",
    WebStringKey.HeroDescription to "Mehr Guard วิเคราะห์ภัยคุกคามที่อาจเกิดขึ้นโดยตรงบนฮาร์ดแวร์ของคุณ สัมผัสการป้องกันที่ไม่มีความหน่วง",

    // Dashboard
    WebStringKey.StartScan to "เริ่มการสแกนใหม่",
    WebStringKey.ImportImage to "นำเข้ารูปภาพ",
    WebStringKey.ScanQrCode to "สแกน QR โค้ด",
    WebStringKey.SystemHealth to "สถานะระบบ",
    WebStringKey.ThreatDatabase to "ฐานข้อมูลภัยคุกคาม",
    WebStringKey.Current to "ปัจจุบัน",
    WebStringKey.Active to "ทำงาน",
    WebStringKey.Threats to "ภัยคุกคาม",
    WebStringKey.SafeScans to "การสแกนที่ปลอดภัย",
    WebStringKey.EngineActive to "เครื่องยนต์ทำงาน",
    WebStringKey.EnterpriseProtection to "การป้องกันองค์กรทำงาน",
    WebStringKey.SystemOptimal to "ระบบเหมาะสม",
    WebStringKey.EngineStatus to "เครื่องยนต์ v2.4 • อัปเดต 2 ชม. ที่แล้ว",
    WebStringKey.ThreatsBlocked to "ภัยคุกคามที่ถูกบล็อก",
    WebStringKey.AllSystemsOperational to "ระบบทั้งหมดทำงาน",

    // Dashboard Sections
    WebStringKey.SectionOverview to "ภาพรวม",
    WebStringKey.SectionSecurity to "ความปลอดภัย",
    WebStringKey.SectionTraining to "การฝึกอบรม",
    WebStringKey.SectionReports to "รายงาน",
    WebStringKey.OfflineReady to "พร้อมออฟไลน์",
    WebStringKey.OfflineDescription to "ฐานข้อมูลในเครื่อง v2.4.1 ทำงาน ไม่มีข้อมูลออกจากอุปกรณ์นี้",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "ศูนย์ความน่าเชื่อถือ",
    WebStringKey.OfflineGuarantee to "การรับประกันออฟไลน์อย่างเข้มงวด",
    WebStringKey.OfflineGuaranteeDesc to "การวิเคราะห์ Mehr Guard ทำงานทั้งหมดบน Neural Engine ของอุปกรณ์ ข้อมูล URL ไม่เคยออกจากโทรศัพท์ของคุณ",
    WebStringKey.ThreatSensitivity to "ความไวต่อภัยคุกคาม",
    WebStringKey.ResetConfirm to "การดำเนินการนี้จะรีเซ็ตการตั้งค่าศูนย์ความน่าเชื่อถือทั้งหมดเป็นค่าเริ่มต้น",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "มอนิเตอร์ภัยคุกคาม",
    WebStringKey.ThreatMonitorDesc to "ดูภัยคุกคามสดและเรียกใช้การตรวจสอบความปลอดภัย",
    WebStringKey.TrustCentreDesc to "การตั้งค่าความเป็นส่วนตัวและความไวต่อภัยคุกคาม",
    WebStringKey.ExportReport to "ส่งออกรายงาน",
    WebStringKey.ExportReportDesc to "สร้างรายงานความปลอดภัย PDF หรือ JSON",

    // Dashboard Content
    WebStringKey.Analyze to "วิเคราะห์",
    WebStringKey.HeuristicEngine to "เครื่องยนต์ฮิวริสติก",
    WebStringKey.HighPerformanceEngine to "เครื่องยนต์ประสิทธิภาพสูง",
    WebStringKey.RecentScans to "การสแกนล่าสุด",
    WebStringKey.ViewFullHistory to "ดูประวัติทั้งหมด",
    WebStringKey.Status to "สถานะ",
    WebStringKey.Source to "แหล่งที่มา",
    WebStringKey.Details to "รายละเอียด",
    WebStringKey.Time to "เวลา",
    WebStringKey.Version to "เวอร์ชัน",
    WebStringKey.LastUpdate to "อัปเดตล่าสุด",
    WebStringKey.Signatures to "ลายเซ็น",
    WebStringKey.CheckForUpdates to "ตรวจสอบอัปเดต",
    WebStringKey.FeatureOfflineTitle to "สถาปัตยกรรมออฟไลน์ก่อน",
    WebStringKey.FeatureOfflineDesc to "การวิเคราะห์ทั้งหมดดำเนินการในเครื่อง ฟีดกล้องและข้อมูลที่สแกนของคุณไม่เคยไปถึงเซิร์ฟเวอร์ภายนอก รับประกันความเป็นส่วนตัวอย่างสมบูรณ์",
    WebStringKey.FeatureExplainableTitle to "ความปลอดภัยที่อธิบายได้",
    WebStringKey.FeatureExplainableDesc to "อย่าแค่รับ \"บล็อก\" เราให้การวิเคราะห์ฮิวริสติกโดยละเอียดของพารามิเตอร์ URL การเปลี่ยนเส้นทาง และเพย์โหลด JavaScript",
    WebStringKey.FeaturePerformanceDesc to "ปรับให้เหมาะสำหรับสภาพแวดล้อมเดสก์ท็อป การสแกนประมวลผลใน 5 มิลลิวินาทีโดยใช้ไบนารี Kotlin Multiplatform",
    WebStringKey.TrainingCentre to "ศูนย์ฝึกอบรม",
    WebStringKey.LearnHomograph to "เรียนรู้วิธีระบุการโจมตีโฮโมกราฟ QR ขั้นสูง",
    WebStringKey.BeatTheBotAction to "เอาชนะบอท →",
    WebStringKey.NoScansYet to "ยังไม่มีการสแกน เริ่มการสแกนใหม่เพื่อดูผลลัพธ์ที่นี่",
    WebStringKey.VerdictSafe to "ปลอดภัย",
    WebStringKey.VerdictPhish to "ฟิชชิ่ง",
    WebStringKey.VerdictWarn to "เตือน",
    WebStringKey.ScoreLabel to "คะแนน:",

    // Scanner
    WebStringKey.ActiveScanner to "เครื่องสแกนที่ทำงาน",
    WebStringKey.OfflineMode to "โหมดออฟไลน์",
    WebStringKey.LiveFeedDisconnected to "ฟีดสดถูกตัดการเชื่อมต่อ",
    WebStringKey.CameraAccessRequired to "ต้องการการเข้าถึงกล้อง",
    WebStringKey.CameraAccessDescription to "ลากและวางรูปภาพ QR โค้ดที่นี่หรือเปิดใช้งานการเข้าถึงกล้องเพื่อเริ่มสแกน",
    WebStringKey.EnableCamera to "เปิดใช้งานกล้อง",
    WebStringKey.Scanning to "กำลังสแกน...",
    WebStringKey.ScanHint to "ถือให้นิ่ง วิเคราะห์ออฟไลน์ใน <5ms",
    WebStringKey.Torch to "ไฟฉาย",
    WebStringKey.Gallery to "แกลเลอรี",
    WebStringKey.PasteUrl to "วาง URL",
    WebStringKey.PasteUrlTitle to "วาง URL เพื่อวิเคราะห์",
    WebStringKey.AnalyzeUrl to "วิเคราะห์ URL",
    WebStringKey.SystemStatus to "สถานะระบบ",
    WebStringKey.PhishingEngine to "เครื่องยนต์ฟิชชิ่ง",
    WebStringKey.Ready to "พร้อม",
    WebStringKey.LocalDb to "DB ในเครื่อง",
    WebStringKey.Latency to "ความหน่วง",
    WebStringKey.ViewAll to "ดูทั้งหมด",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "หน้าแรก",
    WebStringKey.BreadcrumbScans to "การสแกน",
    WebStringKey.OfflineProtection to "การป้องกันออฟไลน์",
    WebStringKey.VerdictHighRisk to "ตรวจพบความเสี่ยงสูง",
    WebStringKey.VerdictDangerous to "อันตราย",
    WebStringKey.VerdictDangerousDesc to "QR โค้ดที่สแกนมีตัวบ่งชี้อันตรายที่เกี่ยวข้องกับฟิชชิ่งและการเก็บเกี่ยวข้อมูลรับรอง อย่าดำเนินการต่อไปยัง URL เป้าหมาย",
    WebStringKey.ThreatConfidence to "ความมั่นใจในภัยคุกคาม",
    WebStringKey.FlagPhishing to "ความพยายามฟิชชิ่ง",
    WebStringKey.FlagObfuscated to "สคริปต์ที่ปิดบัง",
    WebStringKey.FlagHomograph to "การโจมตีโฮโมกราฟ",
    WebStringKey.ClearHistory to "ล้างทั้งหมด",
    WebStringKey.SectionAttackBreakdown to "การวิเคราะห์การโจมตี",
    WebStringKey.AttackHomographTitle to "การโจมตี Homograph / IDN",
    WebStringKey.AttackHomographDesc to "ตรวจพบอักขระซีริลลิกที่เลียนแบบตัวอักษรละติน",
    WebStringKey.AttackVisualLabel to "ลักษณะที่ปรากฏ",
    WebStringKey.AttackPunycodeLabel to "Punycode จริง",
    WebStringKey.AttackHomographExplain to "โดเมนใช้ 'а' ซีริลลิก (U+0430) แทน 'a' ละติน (U+0061) เทคนิคนี้มักใช้เพื่อหลอกผู้ใช้ให้เชื่อว่าพวกเขากำลังเยี่ยมชมบริการที่ถูกต้อง",
    WebStringKey.AttackRedirectTitle to "ห่วงโซ่การเปลี่ยนเส้นทางที่น่าสงสัย",
    WebStringKey.AttackRedirectDesc to "ตรวจพบ 3 ฮอปที่เกี่ยวข้องกับตัวย่อ URL ที่รู้จัก",
    WebStringKey.RedirectStart to "สแกน QR โค้ด",
    WebStringKey.RedirectHop to "ฮอประหว่างกลาง",
    WebStringKey.RedirectFinal to "ปลายทางสุดท้าย",
    WebStringKey.AttackJsTitle to "JavaScript ที่ปิดบัง",
    WebStringKey.AttackJsDesc to "ตรวจพบสตริงเอนโทรปีสูงในพารามิเตอร์ URL",
    WebStringKey.SectionActions to "การดำเนินการที่แนะนำ",
    WebStringKey.ActionBlock to "บล็อก & รายงาน",
    WebStringKey.ActionBlockDesc to "ป้องกันการเข้าถึงและแจ้งผู้ดูแลระบบ",
    WebStringKey.ActionQuarantine to "กักกันใน Sandbox",
    WebStringKey.ActionQuarantineDesc to "เปิดอย่างปลอดภัยเพื่อวิเคราะห์",
    WebStringKey.Expected to "คาดหวัง: ",
    WebStringKey.Detected to "ตรวจพบ: ",
    WebStringKey.ExplainableSecurity to "ความปลอดภัยที่อธิบายได้",
    WebStringKey.UrlBreakdown to "การวิเคราะห์ URL",
    WebStringKey.FullUrl to "URL ฉบับเต็ม",
    WebStringKey.OpenInBrowser to "เปิดในเบราว์เซอร์ (มีความเสี่ยง)",
    WebStringKey.OpenWarning to "การเปิด URL นี้ในเบราว์เซอร์อาจทำให้คุณเสี่ยงต่อความปลอดภัย",
    WebStringKey.RestrictedMode to "โหมดจำกัด",
    WebStringKey.RestrictedDesc to "URL นี้ถูกทำเครื่องหมายว่าอาจเป็นอันตราย ตรวจสอบการวิเคราะห์ด้านล่างก่อนดำเนินการต่อ",
    WebStringKey.DangerousWarning to "URL นี้ถูกทำเครื่องหมายว่าอาจเป็นอันตราย การเปิดอาจทำให้คุณเสี่ยงต่อฟิชชิ่ง มัลแวร์ หรือภัยคุกคามความปลอดภัยอื่นๆ คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    WebStringKey.CopyUrl to "คัดลอก URL",
    WebStringKey.Share to "แชร์",
    WebStringKey.Dismiss to "ปิด",
    WebStringKey.ReasonDomainAge to "อายุโดเมนน้อยกว่า 24 ชั่วโมง",
    WebStringKey.ReasonSignatures to "ตรงกับ 3 ลายเซ็นใน DB ฟิชชิ่งในเครื่อง",
    WebStringKey.ReasonAsn to "IP เป้าหมายตั้งอยู่ใน ASN ที่มีความเสี่ยงสูง",
    WebStringKey.SectionMeta to "ข้อมูลเมตาการสแกน",
    WebStringKey.MetaTime to "เวลาสแกน",
    WebStringKey.MetaSource to "แหล่งที่มา",
    WebStringKey.MetaEngine to "เครื่องยนต์",
    WebStringKey.MetaOfflineGuaranteeLabel to "การรับประกันออฟไลน์:",
    WebStringKey.MetaOfflineGuaranteeDesc to "รูปภาพนี้ถูกวิเคราะห์ในเครื่องบนอุปกรณ์ของคุณ ไม่มีข้อมูลถูกส่งไปยังคลาวด์สำหรับคำตัดสินนี้",
    
    WebStringKey.ScanComplete to "สแกนเสร็จสมบูรณ์",
    WebStringKey.Loading to "กำลังโหลด...",
    WebStringKey.AnalyzedOffline to "วิเคราะห์ออฟไลน์ใน <5ms",
    WebStringKey.NoDataLeaves to "ข้อมูลไม่ออกจากอุปกรณ์",
    WebStringKey.ActiveProtection to "การป้องกันที่ใช้งานอยู่",
    WebStringKey.ConfidenceScore to "คะแนนความมั่นใจ",
    WebStringKey.Analyzing to "กำลังวิเคราะห์...",
    WebStringKey.ProcessingResults to "กำลังประมวลผลผลลัพธ์การสแกน...",
    WebStringKey.RiskAssessment to "การประเมินความเสี่ยง",
    WebStringKey.AnalysisTime to "เวลาวิเคราะห์",
    WebStringKey.Heuristics to "ฮิวริสติก",
    WebStringKey.TopAnalysisFactors to "ปัจจัยการวิเคราะห์หลัก",
    WebStringKey.Pass to "ผ่าน",
    WebStringKey.Info to "ข้อมูล",
    WebStringKey.Clean to "สะอาด",
    WebStringKey.ValidSslCertificate to "ใบรับรอง SSL ที่ถูกต้อง",
    WebStringKey.SslCertificateDesc to "ใบรับรองออกโดย DigiCert Inc",
    WebStringKey.EstablishedDomain to "โดเมนที่จัดตั้งแล้ว",
    WebStringKey.EstablishedDomainDesc to "โดเมนลงทะเบียนมากกว่า 5 ปี",
    WebStringKey.BlacklistStatus to "สถานะบัญชีดำ",
    WebStringKey.BlacklistStatusDesc to "ไม่พบใน 52 ฐานข้อมูลภัยคุกคามในเครื่อง",
    WebStringKey.BackToDashboard to "กลับไปยังแดชบอร์ด",
    WebStringKey.ShareReport to "แชร์รายงาน",
    WebStringKey.CopyLink to "คัดลอกลิงก์",
    WebStringKey.LinkCopied to "คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว!",
    WebStringKey.BeatTheBot to "เอาชนะบอท",
    WebStringKey.BeatTheBotDesc to "ท้าทาย AI ออฟไลน์ของเรา",
    WebStringKey.SessionId to "ID เซสชัน",
    WebStringKey.EndSession to "สิ้นสุดเซสชัน",
    WebStringKey.Round to "รอบ",
    WebStringKey.BrowserPreview to "ตัวอย่างเบราว์เซอร์",
    WebStringKey.MakeDecision to "ตัดสินใจของคุณ",
    WebStringKey.Phishing to "ฟิชชิ่ง",
    WebStringKey.Legitimate to "ถูกต้อง",
    WebStringKey.LiveHint to "คำใบ้สด",
    WebStringKey.LiveScoreboard to "กระดานคะแนนสด",
    WebStringKey.VsMode to "โหมด VS",
    WebStringKey.You to "คุณ",
    WebStringKey.Points to "คะแนน",
    WebStringKey.Streak to "ต่อเนื่อง",
    WebStringKey.Accuracy to "ความแม่นยำ",
    WebStringKey.MehrGuardBot to "Mehr Guard บอท",
    WebStringKey.Confidence to "ความมั่นใจ",
    WebStringKey.RoundAnalysis to "การวิเคราะห์รอบ",
    WebStringKey.Analysis to "การวิเคราะห์",
    WebStringKey.CorrectDecision to "ตัดสินใจถูกต้อง!",
    WebStringKey.IdentifiedSafe to "คุณระบุ URL ที่ปลอดภัยได้ถูกต้อง",
    WebStringKey.AiNeuralAnalysis to "การวิเคราะห์ AI Neural",
    WebStringKey.WhyBotFlagged to "ทำไมบอทถึงแฟล็ก",
    WebStringKey.EducationalNote to "หมายเหตุการศึกษา",
    WebStringKey.Correct to "ถูกต้อง!",
    WebStringKey.SpottedPhishing to "คุณตรวจพบ URL ฟิชชิ่งได้ถูกต้อง",
    WebStringKey.Response to "การตอบสนอง",
    WebStringKey.NextRound to "รอบถัดไป",
    WebStringKey.GameOver to "จบเกม!",
    WebStringKey.FinalResults to "ผลลัพธ์สุดท้าย",
    WebStringKey.YourScore to "คะแนนของคุณ",
    WebStringKey.BotScore to "คะแนนบอท",
    WebStringKey.BestStreak to "ต่อเนื่องที่ดีที่สุด",
    WebStringKey.PlayAgain to "เล่นอีกครั้ง",
    WebStringKey.ReturnToDashboard to "กลับไปยังแดชบอร์ด",
    WebStringKey.ExportSecurityReport to "ส่งออกรายงานความปลอดภัย",
    WebStringKey.GenerateReport to "สร้างรายงานความปลอดภัยฉบับเต็ม",
    WebStringKey.ReportFormat to "รูปแบบรายงาน",
    WebStringKey.HumanReadable to "รายงานที่มนุษย์อ่านได้",
    WebStringKey.HumanReadableDesc to "PDF พร้อมการวิเคราะห์ภาพ",
    WebStringKey.MachineReadable to "ข้อมูลที่เครื่องอ่านได้",
    WebStringKey.MachineReadableDesc to "รูปแบบ JSON สำหรับการรวม SIEM",
    WebStringKey.DateRange to "ช่วงวันที่",
    WebStringKey.Last7Days to "7 วันที่ผ่านมา",
    WebStringKey.Last30Days to "30 วันที่ผ่านมา",
    WebStringKey.Last90Days to "90 วันที่ผ่านมา",
    WebStringKey.AllTime to "ทั้งหมด",
    WebStringKey.CustomRange to "ช่วงที่กำหนดเอง",
    WebStringKey.ReportSections to "ส่วนของรายงาน",
    WebStringKey.ExecutiveSummary to "สรุป",
    WebStringKey.ThreatBreakdown to "การวิเคราะห์ภัยคุกคาม",
    WebStringKey.ScanTimeline to "ไทม์ไลน์การสแกน",
    WebStringKey.SafeUrlList to "รายการ URL ที่ปลอดภัย",
    WebStringKey.GenerateExport to "ส่งออกรายงาน",
    WebStringKey.Success to "สำเร็จ!",
    WebStringKey.Error to "ข้อผิดพลาด",
    WebStringKey.Warning to "คำเตือน",
    WebStringKey.CopiedToClipboard to "คัดลอกไปยังคลิปบอร์ดแล้ว",
    WebStringKey.Cancel to "ยกเลิก",
    WebStringKey.Confirm to "ยืนยัน",
    WebStringKey.Save to "บันทึก",
    WebStringKey.Delete to "ลบ",
    WebStringKey.Edit to "แก้ไข",
    WebStringKey.Close to "ปิด",
    WebStringKey.Back to "กลับ",
    WebStringKey.Next to "ถัดไป",
    WebStringKey.Previous to "ก่อนหน้า",
    WebStringKey.Submit to "ส่ง",
    WebStringKey.Reset to "รีเซ็ต",
    WebStringKey.Clear to "ล้าง",
    WebStringKey.Search to "ค้นหา",
    WebStringKey.Filter to "กรอง",
    WebStringKey.Sort to "เรียงลำดับ",
    WebStringKey.ToggleMenu to "สลับเมนู",
    WebStringKey.ToggleTheme to "สลับธีม",
    WebStringKey.Notifications to "การแจ้งเตือน",
    WebStringKey.Help to "ความช่วยเหลือ",
    WebStringKey.Profile to "โปรไฟล์",
    WebStringKey.ToggleLightDarkMode to "สลับโหมดสว่าง/มืด",
    WebStringKey.UrlInputPlaceholder to "วาง URL เพื่อวิเคราะห์",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.Scan to "สแกน",
    WebStringKey.Result to "ผลลัพธ์",
    WebStringKey.ReportGeneration to "การสร้างรายงาน",
    WebStringKey.ReportGenerationDesc to "กำหนดค่ารูปแบบและดาวน์โหลด",
    WebStringKey.OfflineSecurity to "ความปลอดภัยออฟไลน์",
    WebStringKey.OfflineSecurityDesc to "ข้อมูลไม่ออกจากอุปกรณ์นี้",
    WebStringKey.ChooseFormat to "เลือกรูปแบบ",
    WebStringKey.PdfFormatDesc to "รูปแบบ PDF เหมาะสำหรับแชร์",
    WebStringKey.JsonFormatDesc to "รูปแบบ JSON เหมาะสำหรับ SIEM",
    WebStringKey.Copy to "คัดลอก",
    WebStringKey.LivePreview to "ตัวอย่างสด",
    WebStringKey.ReadOnly to "อ่านอย่างเดียว",
    WebStringKey.ThreatAnalysisReport to "รายงานการวิเคราะห์ภัยคุกคาม",
    WebStringKey.Verdict to "คำตัดสิน",
    WebStringKey.RiskScore to "คะแนนความเสี่ยง",
    WebStringKey.TargetUrl to "URL เป้าหมาย",
    WebStringKey.AnalysisSummaryLabel to "สรุปการวิเคราะห์",
    WebStringKey.TechnicalIndicators to "ตัวบ่งชี้ทางเทคนิค",
    WebStringKey.ExportInfoNote to "รวมเวกเตอร์ภัยคุกคามทั้งหมด",
    WebStringKey.AllowList to "รายการอนุญาต",
    WebStringKey.BlockList to "รายการบล็อก",
    WebStringKey.AddDomain to "เพิ่มโดเมน",
    WebStringKey.RemoveDomain to "ลบโดเมน",
    WebStringKey.TrustedDomains to "โดเมนที่เชื่อถือได้",
    WebStringKey.BlockedDomains to "โดเมนที่ถูกบล็อก",
    WebStringKey.DomainPlaceholder to "ป้อนโดเมน",
    WebStringKey.Safe to "ปลอดภัย",
    WebStringKey.TimeAgo to "ที่ผ่านมา",
    WebStringKey.MinutesAgo to "นาทีที่ผ่านมา",
    WebStringKey.HoursAgo to "ชั่วโมงที่ผ่านมา",
    WebStringKey.Critical to "วิกฤต",
    WebStringKey.Warn to "เตือน",
    WebStringKey.PhishingDetectionSensitivity to "ความไวในการตรวจจับฟิชชิ่ง",
    WebStringKey.SensitivityDescription to "ปรับเกณฑ์ฮิวริสติก",
    WebStringKey.SensitivityLow to "ต่ำ",
    WebStringKey.SensitivityBalanced to "สมดุล",
    WebStringKey.SensitivityParanoia to "หวาดระแวง",
    WebStringKey.BalancedModeRecommended to "โหมดสมดุล (แนะนำ)",
    WebStringKey.BalancedModeDesc to "สแกนรูปแบบที่เป็นอันตราย",
    WebStringKey.LowSensitivityMode to "โหมดความไวต่ำ",
    WebStringKey.LowSensitivityModeDesc to "บล็อกเฉพาะ URL ที่เป็นอันตรายที่รู้จักจากฐานข้อมูลภัยคุกคาม ผลบวกปลอมน้อยที่สุด แต่อาจพลาดการโจมตีใหม่",
    WebStringKey.ParanoiaMode to "โหมดหวาดระแวง",
    WebStringKey.ParanoiaModeDesc to "การป้องกันสูงสุด บล็อกรูปแบบที่น่าสงสัยทั้งหมดรวมถึงโดเมนที่ลงทะเบียนใหม่ TLD ที่ไม่ปกติ และ URL ที่มีเทคนิคการเข้ารหัสที่อาจเป็นปัญหา",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard ใช้เอ็นจิ้นวิเคราะห์ฮิวริสติกในเครื่อง ไม่มีข้อมูลรูปภาพ สตริง URL หรือเมตาดาต้าออกจากอุปกรณ์นี้ระหว่างการสแกน ความเป็นส่วนตัวของคุณได้รับการรับประกันทางคณิตศาสตร์",
    WebStringKey.SignalBrandImpersonation to "ตรวจพบการปลอมแปลงแบรนด์ที่อาจเป็นไปได้",
    WebStringKey.SignalCredentialParams to "พารามิเตอร์ที่เกี่ยวข้องกับข้อมูลรับรองใน URL",
    WebStringKey.SignalEncodedPayload to "ตรวจพบข้อมูลที่เข้ารหัสในพารามิเตอร์การค้นหา",
    WebStringKey.SignalExcessiveSubdomains to "ความลึกของซับโดเมนมากเกินไป ({count} ระดับ)",
    WebStringKey.SignalHighEntropyHost to "ความสุ่มสูงในชื่อโดเมน",
    WebStringKey.SignalHomographAttack to "โดเมนมีตัวอักษรโฮโมกราฟ/ที่สับสนได้",
    WebStringKey.SignalHttpNotHttps to "ใช้โปรโตคอล HTTP ที่ไม่ปลอดภัย",
    WebStringKey.SignalIpAddressHost to "โฮสต์เป็นที่อยู่ IP แทนโดเมน",
    WebStringKey.SignalLongUrl to "URL ยาวผิดปกติ ({length} ตัวอักษร)",
    WebStringKey.SignalLongUrlMarketing to "URL ยาวผิดปกติ ({length} ตัวอักษร) - มีพารามิเตอร์การตลาด",
    WebStringKey.SignalNewlyRegisteredDomain to "ตรวจพบโดเมนที่ลงทะเบียนใหม่",
    WebStringKey.SignalNonStandardPort to "พอร์ตไม่มาตรฐาน: {port}",
    WebStringKey.SignalNumericSubdomain to "ตรวจพบซับโดเมนที่เป็นตัวเลขเท่านั้น",
    WebStringKey.SignalSuspiciousPathKeywords to "คำสำคัญที่น่าสงสัยในเส้นทาง ({count} พบ)",
    WebStringKey.SignalSuspiciousTld to "TLD ที่น่าสงสัย: {tld}",
    WebStringKey.SignalUrlShortener to "ใช้บริการย่อ URL",
    WebStringKey.SecureEnvironment to "สภาพแวดล้อมที่ปลอดภัย",
    WebStringKey.LearnLocalArchitecture to "เรียนรู้สถาปัตยกรรมในเครื่อง",
    WebStringKey.NoCustomDomainsBlocked to "ไม่มีโดเมนที่กำหนดเองถูกบล็อก",
    WebStringKey.AddManually to "เพิ่มด้วยตนเอง",
    WebStringKey.AddedDaysAgo to "เพิ่มเมื่อ 2 วันที่ผ่านมา",
    WebStringKey.AddedWeekAgo to "เพิ่มเมื่อ 1 สัปดาห์ที่ผ่านมา",
    WebStringKey.PrivacyControls to "การควบคุมความเป็นส่วนตัว",
    WebStringKey.StrictOfflineMode to "โหมดออฟไลน์อย่างเข้มงวด",
    WebStringKey.DisableExternalPreviews to "ปิดใช้งานตัวอย่างภายนอก",
    WebStringKey.AnonymousTelemetry to "การส่งข้อมูลแบบไม่ระบุตัวตน",
    WebStringKey.ShareDetectionStats to "แชร์สถิติการตรวจจับ",
    WebStringKey.AutoCopySafeLinks to "คัดลอกลิงก์ที่ปลอดภัยอัตโนมัติ",
    WebStringKey.CopyTrustedUrls to "คัดลอก URL ที่เชื่อถือได้",
    WebStringKey.AboutMehrGuard to "เกี่ยวกับ Mehr Guard",
    WebStringKey.OpenSourceLicenses to "ใบอนุญาตโอเพนซอร์ส",
    WebStringKey.PrivacyPolicy to "นโยบายความเป็นส่วนตัว",
    WebStringKey.Acknowledgements to "กิตติกรรมประกาศ",
    WebStringKey.ResetAllSettings to "รีเซ็ตการตั้งค่าทั้งหมด",
    WebStringKey.AddToAllowlist to "เพิ่มไปยังรายการอนุญาต",
    WebStringKey.AddToBlocklist to "เพิ่มไปยังรายการบล็อก",
    WebStringKey.AnalysedOfflineTitle to "วิเคราะห์ออฟไลน์",
    WebStringKey.YourDataStaysOnDevice to "ข้อมูลยังคงอยู่บนอุปกรณ์",
    WebStringKey.OnboardingHeroDesc to "การวิเคราะห์บนอุปกรณ์ที่ปลอดภัย",
    WebStringKey.OnDeviceAnalysis to "การวิเคราะห์บนอุปกรณ์",
    WebStringKey.OnDeviceAnalysisDesc to "การตรวจจับภัยคุกคามทั้งหมดทำงานในเครื่อง",
    WebStringKey.NoCloudLogs to "ไม่มีบันทึกคลาวด์",
    WebStringKey.NoCloudLogsDesc to "ปิดใช้งานการส่งข้อมูลออก",
    WebStringKey.OnDeviceDB to "ฐานข้อมูลบนอุปกรณ์",
    WebStringKey.OnDeviceDBDesc to "ฐานข้อมูลลายเซ็นภัยคุกคามฉบับเต็ม",
    WebStringKey.DataLifecycleVerification to "การตรวจสอบวงจรชีวิตข้อมูล",
    WebStringKey.SecurityAuditPass to "การตรวจสอบความปลอดภัย: ผ่าน",
    WebStringKey.Copyright to "© 2025-2026 Mehr Guard Security Inc.",
    WebStringKey.Support to "สนับสนุน",
    WebStringKey.Terms to "เงื่อนไข",
    WebStringKey.SystemsOperational to "ระบบทำงาน",
    WebStringKey.SystemSecure to "ระบบปลอดภัย",
    WebStringKey.VersionStatus to "v2.4.1 • ระบบปลอดภัย",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "ยืนยันโดย Mehr Guard Enterprise",
    WebStringKey.SampleUserName to "สมชาย ใจดี",
    WebStringKey.SampleUserRole to "นักวิเคราะห์ความปลอดภัย",
    WebStringKey.DetailLabel to "ป้ายกำกับรายละเอียด",
    WebStringKey.DetailValue to "ค่ารายละเอียด",
    WebStringKey.Suspicious to "น่าสงสัย",
    WebStringKey.IncorrectDecision to "ตัดสินใจผิด",
    WebStringKey.WrongAnswer to "อุ๊ปส์! นั่นผิด",
    WebStringKey.ResponseTime to "เวลาตอบสนอง",
    WebStringKey.IncomingMessage to "ข้อความขาเข้า",
    WebStringKey.CertificateIssuer to "ผู้ออกใบรับรองตรงกัน",
    WebStringKey.DomainAgeTrust to "อายุโดเมน > 5 ปี",
    WebStringKey.WhitelistedRank to "Alexa อันดับ 1k",
    WebStringKey.GameEducationalNote to "หมายเหตุการศึกษา",
    WebStringKey.GameHintTitle to "คำใบ้เกม",
    WebStringKey.AddToAllowlistTitle to "เพิ่มไปยังรายการอนุญาต",
    WebStringKey.AddToBlocklistTitle to "เพิ่มไปยังรายการบล็อก",
    WebStringKey.EnterDomainPrompt to "ป้อนโดเมน",
    WebStringKey.LatencyMs to "ความหน่วง",
    WebStringKey.StreakFire to "ต่อเนื่อง",
    WebStringKey.AccuracyPercent to "ความแม่นยำ",
    WebStringKey.ConfidencePercent to "ความมั่นใจ",
    WebStringKey.English to "อังกฤษ",
    WebStringKey.German to "เยอรมัน",
    WebStringKey.Spanish to "สเปน",
    WebStringKey.French to "ฝรั่งเศส",
    WebStringKey.ChineseSimplified to "จีน (ตัวย่อ)",
    WebStringKey.Japanese to "ญี่ปุ่น",
    WebStringKey.Hindi to "ฮินดี",
    WebStringKey.Arabic to "อาหรับ",
    WebStringKey.Indonesian to "อินโดนีเซีย",
    WebStringKey.Italian to "อิตาลี",
    WebStringKey.Korean to "เกาหลี",
    WebStringKey.Portuguese to "โปรตุเกส",
    WebStringKey.Russian to "รัสเซีย",
    WebStringKey.Thai to "ไทย",
    WebStringKey.Turkish to "ตุรกี",
    WebStringKey.Vietnamese to "เวียดนาม"
,
    WebStringKey.ComponentVoting to "การโหวตส่วนประกอบ",
    WebStringKey.Heuristic to "ฮิวริสติก",
    WebStringKey.MLModel to "โมเดล ML",
    WebStringKey.Brand to "แบรนด์",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "เสียงข้างมากกำหนดผล: 3+ ปลอดภัย=เขียว, 2+ อันตราย=แดง"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "รอการสแกน...",
    WebStringKey.WaitingForAnalysis to "รอการวิเคราะห์...",
    WebStringKey.ScanURLToSeeResults to "สแกน URL เพื่อดูผลลัพธ์โดยละเอียด",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "ทางลัดคีย์บอร์ด",
    WebStringKey.StartScanner to "เริ่มสแกนเนอร์",
    WebStringKey.CloseMenuModal to "ปิดเมนู / หน้าต่าง",
    WebStringKey.NavigateToDashboard to "ไปที่แดชบอร์ด",
    WebStringKey.NavigateToHistory to "ประวัติการสแกน",
    WebStringKey.NavigateToTrust to "ศูนย์ความไว้วางใจ / รายการอนุญาต",
    WebStringKey.NavigateToGame to "เกมเอาชนะบอท",
    WebStringKey.ShowHelp to "แสดงวิธีใช้",
    WebStringKey.GotIt to "เข้าใจแล้ว",
    WebStringKey.SecuritySettings to "การตั้งค่าความปลอดภัย",
    WebStringKey.SensitivityLevel to "ระดับความไว",
    WebStringKey.AutoBlockThreats to "บล็อกภัยคุกคามอัตโนมัติ",
    WebStringKey.RealTimeScanning to "สแกนแบบเรียลไทม์",
    WebStringKey.SoundAlerts to "การแจ้งเตือนเสียง",
    WebStringKey.ThreatAlerts to "การแจ้งเตือนภัยคุกคาม",
    WebStringKey.ShowConfidenceScore to "แสดงคะแนนความมั่นใจ",
    WebStringKey.CompactView to "มุมมองกระชับ",
    WebStringKey.ResetDefaults to "รีเซ็ตเป็นค่าเริ่มต้น",
    WebStringKey.SaveAndContinue to "บันทึกและดำเนินการต่อ",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "กิจกรรมที่น่าสงสัย",
    WebStringKey.VerdictWarning to "คำเตือน",
    WebStringKey.VerdictSuspiciousDesc to "QR โค้ดที่สแกนแสดงรูปแบบที่น่าสงสัยซึ่งอาจบ่งบอกถึงความเสี่ยงด้านความปลอดภัย โปรดดำเนินการด้วยความระมัดระวัง",
    WebStringKey.VerdictMinorConcerns to "ข้อกังวลเล็กน้อย",
    WebStringKey.VerdictCaution to "ระวัง",
    WebStringKey.VerdictMinorConcernsDesc to "พบข้อกังวลด้านความปลอดภัยเล็กน้อย ลิงก์ดูปลอดภัยเป็นส่วนใหญ่แต่แนะนำให้ตรวจสอบ",
    WebStringKey.VerdictVerifiedSafe to "ตรวจสอบแล้วปลอดภัย",
    WebStringKey.VerdictSafeLabel to "ปลอดภัย",
    WebStringKey.VerdictVerifiedSafeDesc to "ไม่พบภัยคุกคามด้านความปลอดภัย QR โค้ดนำไปสู่ปลายทางที่ตรวจสอบแล้วว่าปลอดภัย",
    WebStringKey.VerdictNoActivity to "ไม่มีกิจกรรม",
    WebStringKey.VerdictAwaitingScan to "รอการสแกน",
    WebStringKey.VerdictNoActivityDesc to "ไม่มีข้อมูลการสแกน กรุณาสแกน QR โค้ดหรือป้อน URL เพื่อวิเคราะห์",
    WebStringKey.ScanQrToSeeActivity to "สแกน QR โค้ดเพื่อดูกิจกรรมของคุณที่นี่",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "จุดข้อมูล",
    WebStringKey.ProcessingEnv to "สภาพแวดล้อมการประมวลผล",
    WebStringKey.ExternalTransmission to "การส่งข้อมูลภายนอก",
    WebStringKey.RawImageBuffer to "บัฟเฟอร์ภาพดิบ",
    WebStringKey.LocalMemoryRam to "หน่วยความจำท้องถิ่น (RAM)",
    WebStringKey.TransmissionNone to "ไม่มี",
    WebStringKey.DecodedUrlPayload to "URL/เพย์โหลดที่ถอดรหัส",
    WebStringKey.LocalAnalysis to "การวิเคราะห์ท้องถิ่น",
    WebStringKey.ThreatVerdictLabel to "ผลตัดสินภัยคุกคาม",
    WebStringKey.LocalDatabase to "ฐานข้อมูลท้องถิ่น",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "เกี่ยวกับ Mehr Guard Security",
    WebStringKey.ActualDomain to "โดเมนจริง",
    WebStringKey.AnalysisComplete to "การวิเคราะห์เสร็จสมบูรณ์",
    WebStringKey.AutoBlockThreatsDesc to "บล็อกภัยคุกคามโดยอัตโนมัติ",
    WebStringKey.AwaitingScanLabel to "รอการสแกน",
    WebStringKey.BrandImpersonation to "การปลอมแบรนด์",
    WebStringKey.CautionAdvised to "แนะนำให้ระวัง",
    WebStringKey.CompactViewDesc to "มุมมองกะทัดรัด",
    WebStringKey.DoNotVisit to "อย่าเข้าชม",
    WebStringKey.DoNotVisitDesc to "ตรวจพบฟิชชิ่งความน่าเชื่อถือสูง URL นี้แสดงตัวบ่งชี้ที่เป็นอันตรายหลายรายการ",
    WebStringKey.DomainUsesInternationalChars to "โดเมนนี้ใช้อักขระระหว่างประเทศที่อาจเลียนแบบโดเมนที่ถูกต้อง",
    WebStringKey.GoToScanner to "ไปที่สแกนเนอร์",
    WebStringKey.Hebrew to "ฮีบรู",
    WebStringKey.HelpKeyboardShortcuts to "แป้นพิมพ์ลัด",
    WebStringKey.HeuristicAnalysis to "การวิเคราะห์ฮิวริสติก",
    WebStringKey.HeuristicAnalysisDesc to "URL ถูกทำเครื่องหมายตามปัจจัยเสี่ยงหลายรายการที่เครื่องมือวิเคราะห์ตรวจพบ",
    WebStringKey.HiddenDestination to "ปลายทางที่ซ่อนอยู่",
    WebStringKey.HighRisk to "ความเสี่ยงสูง",
    WebStringKey.HighRiskLabel to "ความเสี่ยงสูง",
    WebStringKey.HomographIdnAttack to "การโจมตี Homograph / IDN",
    WebStringKey.InternationalizedDomainDetected to "ตรวจพบชื่อโดเมนระหว่างประเทศ",
    WebStringKey.JustNow to "เมื่อสักครู่",
    WebStringKey.KeyboardShortcutsDesc to "แป้นพิมพ์ลัดสำหรับการเข้าถึงอย่างรวดเร็ว",
    WebStringKey.LiveFeedActive to "ฟีดสดทำงานอยู่",
    WebStringKey.LowRisk to "ความเสี่ยงต่ำ",
    WebStringKey.LowRiskLabel to "ความเสี่ยงต่ำ",
    WebStringKey.Malicious to "เป็นอันตราย",
    WebStringKey.MediumRiskLabel to "ความเสี่ยงปานกลาง",
    WebStringKey.NoData to "ไม่มีข้อมูล",
    WebStringKey.NoScanDataResults to "ไม่มีข้อมูลการสแกน กรุณาสแกน URL เพื่อดูผลการวิเคราะห์",
    WebStringKey.NoUrlScanned to "ไม่ได้สแกน URL",
    WebStringKey.Persian to "เปอร์เซีย",
    WebStringKey.PhishingIndicators to "ตัวบ่งชี้ฟิชชิ่ง",
    WebStringKey.ProceedWithCaution to "ดำเนินการด้วยความระมัดระวัง",
    WebStringKey.ProceedWithCautionDesc to "ตรวจพบตัวบ่งชี้ที่น่าสงสัยบางรายการ โปรดตรวจสอบแหล่งที่มาก่อนป้อนข้อมูลที่ละเอียดอ่อน",
    WebStringKey.RealTimeScanningDesc to "การสแกนแบบเรียลไทม์",
    WebStringKey.RedirectShortenerDetected to "ตรวจพบการเปลี่ยนเส้นทาง/ตัวย่อ",
    WebStringKey.SafeToVisit to "ปลอดภัยในการเยี่ยมชม",
    WebStringKey.SafeToVisitDesc to "ตรวจสอบโดยฮิวริสติกในเครื่อง v2.4 ไม่พบรูปแบบฟิชชิ่ง สคริปต์ที่ซ่อน หรือการจับคู่บัญชีดำ",
    WebStringKey.SafetyScore to "คะแนนความปลอดภัย",
    WebStringKey.ScanCompleteLabel to "การสแกนเสร็จสมบูรณ์",
    WebStringKey.ScanToAnalyze to "สแกนรหัส QR หรือป้อน URL เพื่อวิเคราะห์",
    WebStringKey.ScannedURLLabel to "URL ที่สแกน",
    WebStringKey.SecuritySignal to "สัญญาณความปลอดภัย",
    WebStringKey.SensitivityLevelDesc to "ระดับความไว",
    WebStringKey.SensitivityPermissive to "อนุญาต",
    WebStringKey.SensitivityStrict to "เข้มงวด",
    WebStringKey.SettingsDetection to "การตรวจจับ",
    WebStringKey.SettingsDisplay to "การแสดงผล",
    WebStringKey.SettingsLanguage to "ภาษา",
    WebStringKey.SettingsLanguageDesc to "เลือกภาษาของอินเทอร์เฟซ",
    WebStringKey.SettingsNotifications to "การแจ้งเตือน",
    WebStringKey.SettingsSavedAutomatically to "การตั้งค่าถูกบันทึกโดยอัตโนมัติและซิงค์ระหว่างเซสชัน",
    WebStringKey.ShowConfidenceScoreDesc to "แสดงคะแนนความเชื่อมั่น",
    WebStringKey.SoundAlertsDesc to "การแจ้งเตือนด้วยเสียง",
    WebStringKey.SuspiciousDomain to "โดเมนที่น่าสงสัย",
    WebStringKey.SuspiciousEncoding to "การเข้ารหัสที่น่าสงสัย",
    WebStringKey.SuspiciousKeywords to "คำหลักที่น่าสงสัย",
    WebStringKey.SuspiciousTld to "TLD ที่น่าสงสัย",
    WebStringKey.SuspiciousTldDesc to "โดเมนใช้ {tld} TLD ที่มักเกี่ยวข้องกับเว็บไซต์ที่เป็นอันตราย",
    WebStringKey.SuspiciousUrlParams to "พารามิเตอร์ URL ที่น่าสงสัย",
    WebStringKey.SuspiciousUrlParamsDesc to "URL มีพารามิเตอร์ที่ซับซ้อนหรืออาจถูกซ่อน",
    WebStringKey.ThreatAlertsDesc to "การแจ้งเตือนภัยคุกคาม",
    WebStringKey.ThreatDetected to "ตรวจพบภัยคุกคาม",
    WebStringKey.UnableToDetermine to "ไม่สามารถระบุคำตัดสินได้ กรุณาลองอีกครั้ง",
    WebStringKey.Unknown to "ไม่ทราบ",
    WebStringKey.UnknownURL to "URL ที่ไม่รู้จัก",
    WebStringKey.UrlShortenerDesc to "URL ใช้บริการย่อที่ซ่อนปลายทางสุดท้าย",
    WebStringKey.UrlShortenerDetected to "ตรวจพบตัวย่อ URL",
    WebStringKey.VersionOfflineReady to "พร้อมใช้งานออฟไลน์",
    WebStringKey.VisualAppearance to "ลักษณะที่ปรากฏ",
    WebStringKey.WaitingForAnalysisLabel to "รอการวิเคราะห์...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "ตรวจพบ JavaScript URL scheme - รันโค้ดเมื่อคลิก",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "ตรวจพบ Data URI scheme - อาจมีโค้ดอันตรายฝังอยู่",
    WebStringKey.ReasonAtSymbolInjectionTitle to "การแทรกสัญลักษณ์ @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL มีสัญลักษณ์ @ แสดงถึงความพยายามขโมยข้อมูลรับรอง",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "การโจมตีด้วยอักขระคล้ายกัน",
    WebStringKey.ReasonHomographDesc to "ชื่อโดเมนระหว่างประเทศ (IDN) อาจเลียนแบบโดเมนอื่น",
    WebStringKey.ReasonMixedScriptTitle to "สคริปต์ผสม",
    WebStringKey.ReasonMixedScriptDesc to "ชื่อโฮสต์มีอักขระจากหลายสคริปต์ (อาจเป็นการปลอมแปลง)",
    WebStringKey.ReasonLookalikeCharsTitle to "อักขระที่คล้ายกัน",
    WebStringKey.ReasonLookalikeCharsDesc to "โดเมนมีอักขระ Unicode ที่ดูคล้ายตัวอักษร ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "อักขระความกว้างศูนย์",
    WebStringKey.ReasonZeroWidthCharsDesc to "ตรวจพบอักขระ Unicode ซ่อนความกว้างศูนย์ (ความพยายามซ่อนเร้น)",
    WebStringKey.ReasonIpHostTitle to "โฮสต์ IP",
    WebStringKey.ReasonIpHostDesc to "URL ใช้ที่อยู่ IP แทนชื่อโดเมน",
    WebStringKey.ReasonCredentialParamTitle to "พารามิเตอร์ข้อมูลรับรอง",
    WebStringKey.ReasonCredentialParamDesc to "URL มีพารามิเตอร์เกี่ยวกับข้อมูลรับรอง (รหัสผ่าน, โทเค็น ฯลฯ)",
    WebStringKey.ReasonBrandImpersonationTitle to "การแอบอ้างแบรนด์",
    WebStringKey.ReasonBrandImpersonationDesc to "URL ดูเหมือนแอบอ้างแบรนด์ที่รู้จัก",
    WebStringKey.ReasonBrandInSubdomainTitle to "แบรนด์ในซับโดเมน",
    WebStringKey.ReasonBrandInSubdomainDesc to "ชื่อแบรนด์ปรากฏในซับโดเมนแต่ไม่ใช่โดเมนหลัก",
    WebStringKey.ReasonRiskyExtensionTitle to "นามสกุลเสี่ยง",
    WebStringKey.ReasonRiskyExtensionDesc to "เส้นทางมีนามสกุลไฟล์ที่อาจเป็นอันตราย",
    WebStringKey.ReasonDoubleExtensionTitle to "นามสกุลคู่",
    WebStringKey.ReasonDoubleExtensionDesc to "ตรวจพบนามสกุลไฟล์คู่ (กลยุทธ์มัลแวร์ทั่วไป)",
    WebStringKey.ReasonEncodedPayloadTitle to "ข้อมูลที่เข้ารหัส",
    WebStringKey.ReasonEncodedPayloadDesc to "ตรวจพบข้อมูลเข้ารหัสขนาดใหญ่ในพารามิเตอร์ URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP ไม่ใช่ HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL ใช้โปรโตคอล HTTP ที่ไม่ปลอดภัยแทน HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD ที่น่าสงสัย",
    WebStringKey.ReasonSuspiciousTldDesc to "โดเมนระดับบนสุดมักถูกใช้สำหรับฟิชชิ่ง",
    WebStringKey.ReasonHighEntropyHostTitle to "โฮสต์เอนโทรปีสูง",
    WebStringKey.ReasonHighEntropyHostDesc to "ชื่อโดเมนดูเหมือนสุ่มสร้างขึ้น",
    WebStringKey.ReasonRedirectParamTitle to "พารามิเตอร์เปลี่ยนเส้นทาง",
    WebStringKey.ReasonRedirectParamDesc to "URL มีพารามิเตอร์เปลี่ยนเส้นทางที่อาจนำไปยังเว็บไซต์อื่น",
    WebStringKey.ReasonDeepSubdomainTitle to "ซับโดเมนลึก",
    WebStringKey.ReasonDeepSubdomainDesc to "ความลึกซับโดเมนมากเกินไป (อาจซ่อนโดเมนจริง)",
    WebStringKey.ReasonMultiTldTitle to "หลาย TLD",
    WebStringKey.ReasonMultiTldDesc to "หลายส่วนที่คล้าย TLD ในชื่อโดเมน",
    WebStringKey.ReasonNumericSubdomainTitle to "ซับโดเมนเป็นตัวเลข",
    WebStringKey.ReasonNumericSubdomainDesc to "ตรวจพบซับโดเมนที่เป็นตัวเลขเท่านั้น",
    WebStringKey.ReasonNonStandardPortTitle to "พอร์ตไม่มาตรฐาน",
    WebStringKey.ReasonNonStandardPortDesc to "URL ใช้หมายเลขพอร์ตไม่มาตรฐาน",
    WebStringKey.ReasonSuspiciousPortTitle to "พอร์ตน่าสงสัย",
    WebStringKey.ReasonSuspiciousPortDesc to "URL ใช้พอร์ตที่มักเกี่ยวข้องกับการโจมตี",
    WebStringKey.ReasonFragmentHidingTitle to "การซ่อนแฟรกเมนต์",
    WebStringKey.ReasonFragmentHidingDesc to "แฟรกเมนต์ URL ดูเหมือนซ่อนเนื้อหาเพิ่มเติม",
    WebStringKey.ReasonExcessiveEncodingTitle to "การเข้ารหัสมากเกินไป",
    WebStringKey.ReasonExcessiveEncodingDesc to "ตรวจพบการเข้ารหัส URL มากเกินไป (ความพยายามซ่อนเร้น)",
    WebStringKey.ReasonDomainAgePatternTitle to "รูปแบบอายุโดเมน",
    WebStringKey.ReasonDomainAgePatternDesc to "ชื่อโดเมนตรงกับรูปแบบโดเมนที่สร้างอัตโนมัติ",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "ตัวย่อ URL",
    WebStringKey.ReasonUrlShortenerDesc to "URL ใช้บริการย่อ (ซ่อนปลายทางจริง)",
    WebStringKey.ReasonSuspiciousPathTitle to "เส้นทางน่าสงสัย",
    WebStringKey.ReasonSuspiciousPathDesc to "เส้นทางมีคำสำคัญที่น่าสงสัย (login, verify ฯลฯ)",
    WebStringKey.ReasonLongUrlTitle to "URL ยาว",
    WebStringKey.ReasonLongUrlDesc to "URL ยาวผิดปกติ",
    WebStringKey.ReasonCredentialKeywordsTitle to "คำสำคัญข้อมูลรับรอง",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL มีคำสำคัญสำหรับเก็บเกี่ยวข้อมูลรับรอง",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL ที่แยกวิเคราะห์ไม่ได้",
    WebStringKey.ReasonUnparseableDesc to "ไม่สามารถแยกวิเคราะห์ URL ได้ทั้งหมด",
    WebStringKey.ReasonAnalysisCompleteTitle to "การวิเคราะห์เสร็จสิ้น",
    WebStringKey.ReasonAnalysisCompleteDesc to "การวิเคราะห์เสร็จสมบูรณ์",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "คะแนนฟิชชิ่ง ML",
    WebStringKey.MlCharacterAnalysis to "การวิเคราะห์อักขระ",
    WebStringKey.MlFeatureAnalysis to "การวิเคราะห์คุณลักษณะ",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "โดเมน IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "โดเมนนี้ใช้อักขระสากล การแสดงผลที่ปลอดภัย:",
    WebStringKey.MixedScriptAttackTitle to "การโจมตีสคริปต์ผสม",
    WebStringKey.MixedScriptAttackDesc to "โดเมนมีอักขระจากหลายสคริปต์ (เช่น ซีริลลิก + ละติน) พบบ่อยในการโจมตีโฮโมกราฟ",
    WebStringKey.ConfusableCharsTitle to "อักขระที่สับสนได้",
    WebStringKey.ConfusableCharsDesc to "โดเมนมีอักขระที่ดูคล้ายกับตัวอักษรทั่วไป (เช่น 'а' vs 'a')"
)

internal val ThaiCommonStrings = mapOf(
    "Engine Active" to "เครื่องยนต์ทำงาน",
    "Enterprise Protection Active" to "การป้องกันองค์กรทำงาน",
    "Secure. Offline.\nExplainable Defence." to "ปลอดภัย ออฟไลน์\nการป้องกันที่อธิบายได้",
    "Start New Scan" to "เริ่มการสแกนใหม่",
    "Import Image" to "นำเข้ารูปภาพ",
    "System Health" to "สถานะระบบ",
    "Threat Database" to "ฐานข้อมูลภัยคุกคาม",
    "Current" to "ปัจจุบัน",
    "Heuristic Engine" to "เครื่องยนต์ฮิวริสติก",
    "Active" to "ทำงาน",
    "Threats" to "ภัยคุกคาม",
    "Safe Scans" to "การสแกนที่ปลอดภัย",
    "Offline-First Architecture" to "สถาปัตยกรรมออฟไลน์ก่อน",
    "Explainable Security" to "ความปลอดภัยที่อธิบายได้",
    "High-Performance Engine" to "เครื่องยนต์ประสิทธิภาพสูง",
    "Recent Scans" to "การสแกนล่าสุด",
    "View Full History" to "ดูประวัติทั้งหมด",
    "Status" to "สถานะ",
    "Source" to "แหล่งที่มา",
    "Details" to "รายละเอียด",
    "Time" to "เวลา",
    "SAFE" to "ปลอดภัย",
    "SUSPICIOUS" to "น่าสงสัย",
    "PHISHING" to "ฟิชชิ่ง",
    "UNKNOWN" to "ไม่ทราบ",
    "Trusted Domain" to "โดเมนที่เชื่อถือได้",
    "Version" to "เวอร์ชัน",
    "Last Update" to "อัปเดตล่าสุด",
    "Signatures" to "ลายเซ็น",
    "Check for Updates" to "ตรวจสอบอัปเดต",
    "WAITING FOR INPUT" to "รอการป้อนข้อมูล",
    "SCANNING" to "กำลังสแกน",
    "ANALYZING" to "กำลังวิเคราะห์",
    "ERROR" to "ข้อผิดพลาด",
    "SCAN COMPLETE" to "สแกนเสร็จสิ้น",
    "Active Scanner" to "เครื่องสแกนที่ทำงาน",
    "Mode:" to "โหมด:",
    "Offline First" to "ออฟไลน์ก่อน",
    "Enable Camera" to "เปิดใช้งานกล้อง",
    "Torch" to "ไฟฉาย",
    "Upload Image" to "อัปโหลดรูปภาพ",
    "Paste URL" to "วาง URL",
    "SYSTEM STATUS" to "สถานะระบบ",
    "Detection Engine" to "เครื่องยนต์ตรวจจับ",
    "Phishing Guard" to "การ์ดฟิชชิ่ง",
    "READY" to "พร้อม",
    "Database" to "ฐานข้อมูล",
    "LATEST" to "ล่าสุด",
    "Latency" to "ความหน่วง",
    "RECENT SCANS" to "การสแกนล่าสุด",
    "View All" to "ดูทั้งหมด",
    "No scans yet" to "ยังไม่มีการสแกน",
    "Export Log" to "ส่งออกบันทึก",
    "Scan History" to "ประวัติการสแกน",
    "Safe" to "ปลอดภัย",
    "Suspicious" to "น่าสงสัย",
    "Dangerous" to "อันตราย",
    "Risk" to "ความเสี่ยง",
    "Verdict" to "คำตัดสิน",
    "Actions" to "การดำเนินการ",
    "Scan" to "สแกน",
    "Results" to "ผลลัพธ์",
    "ENGINE ACTIVE" to "เครื่องยนต์ทำงาน",
    "Safe to Visit" to "ปลอดภัยที่จะเข้าชม",
    "Confidence" to "ความมั่นใจ",
    "Scan Time" to "เวลาสแกน",
    "Engine" to "เครื่องยนต์",
    "Visit URL" to "เยี่ยมชม URL",
    "Copy Safe Link" to "คัดลอกลิงก์ที่ปลอดภัย",
    "Export Report" to "ส่งออกรายงาน",
    "Dashboard" to "แดชบอร์ด",
    "Mehr Guard" to "Mehr Guard",
    "Settings" to "การตั้งค่า",
    "Language" to "ภาษา",
    "Training Centre" to "ศูนย์ฝึกอบรม",
    "Analyze" to "วิเคราะห์"
)
